import * as Common from '@/tenant/common';

export class SalesDeliveryScheduleReportQuery extends Common.ReportQuery {
    constructor(){
        super("SalesDeliveryScheduleReportQuery", null);
    }
    public salesPurchaseFlag: number;
    public deliveryDateFrom: Date = null;
    public deliveryDateTo: Date = null;
    public segment: Common.Segment = null;
    public warehouse: Common.Counterpart = null;
    public noneScheduledFlag: boolean = false;
    public onExcelExport:boolean = false;           
}

export class SalesDeliveryScheduleReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='SalesDeliveryScheduleReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}
